import { axiosICPLBEInstance } from "../../../utils/axios_config";

export default function ProjectSiteService() {
    this.getProjectSites = (payload) => {
        return axiosICPLBEInstance.get(`projectsite?page=${payload.page}&page_length=${payload.page_length}`);
    }
}